import React, { useState } from 'react';
import { Search, RefreshCw } from 'lucide-react';

const TicketUpdate = () => {
  const [ticketId, setTicketId] = useState('');
  const [updateData, setUpdateData] = useState({
    status: '',
    priority: '',
    assignedTo: '',
    notes: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Update ticket:', ticketId, updateData);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Ticket Update</h1>
        <p className="text-sm text-gray-500 mt-1">Update ticket status and details</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Search Ticket */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Ticket ID <span className="text-red-500">*</span>
                </label>
                <div className="flex gap-2">
                  <input
                    type="text"
                    value={ticketId}
                    onChange={(e) => setTicketId(e.target.value)}
                    placeholder="Enter ticket ID"
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    required
                  />
                  <button
                    type="button"
                    className="px-4 py-2 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200"
                  >
                    <Search className="h-5 w-5 text-gray-600" />
                  </button>
                </div>
              </div>

              {/* Update Status */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Update Status
                </label>
                <select
                  value={updateData.status}
                  onChange={(e) => setUpdateData({ ...updateData, status: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select new status</option>
                  <option value="open">Open</option>
                  <option value="in-progress">In Progress</option>
                  <option value="pending">Pending</option>
                  <option value="resolved">Resolved</option>
                  <option value="closed">Closed</option>
                </select>
              </div>

              {/* Update Priority */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Update Priority
                </label>
                <select
                  value={updateData.priority}
                  onChange={(e) => setUpdateData({ ...updateData, priority: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select new priority</option>
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                  <option value="urgent">Urgent</option>
                </select>
              </div>

              {/* Reassign */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Reassign To
                </label>
                <select
                  value={updateData.assignedTo}
                  onChange={(e) => setUpdateData({ ...updateData, assignedTo: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Keep current assignment</option>
                  <option value="support1">Support Team 1</option>
                  <option value="support2">Support Team 2</option>
                  <option value="tech">Technical Team</option>
                  <option value="admin">Admin Team</option>
                </select>
              </div>

              {/* Update Notes */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Update Notes
                </label>
                <textarea
                  value={updateData.notes}
                  onChange={(e) => setUpdateData({ ...updateData, notes: e.target.value })}
                  placeholder="Add notes about this update..."
                  rows="4"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full flex items-center justify-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
              >
                <RefreshCw className="h-5 w-5" />
                Update Ticket
              </button>
            </form>
          </div>
        </div>

        {/* Info Panel */}
        <div className="space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h3 className="font-semibold text-blue-900 mb-2">Update Guidelines</h3>
            <ul className="text-sm text-blue-800 space-y-2">
              <li>• Add notes to track changes</li>
              <li>• Notify relevant team members</li>
              <li>• Update status accurately</li>
              <li>• Set appropriate priority</li>
            </ul>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-4">
            <h3 className="font-semibold text-gray-900 mb-2">Status Guide</h3>
            <div className="space-y-2 text-sm">
              <div>
                <span className="font-medium text-gray-700">Open:</span>
                <p className="text-gray-600">New ticket awaiting review</p>
              </div>
              <div>
                <span className="font-medium text-gray-700">In Progress:</span>
                <p className="text-gray-600">Actively being worked on</p>
              </div>
              <div>
                <span className="font-medium text-gray-700">Resolved:</span>
                <p className="text-gray-600">Issue has been fixed</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketUpdate;